import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/configurationStore";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { getUserDetailsByToken } from "./redux/ducks/user";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";


/**
 * on refresh check whether the user is authenticated or not
 */
 const loginTokenFromSession = sessionStorage.getItem("loginToken");
 if(loginTokenFromSession) {
  store.dispatch(
    getUserDetailsByToken())
 }
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
